export enum CustomerFlow {
  Base = 'base',
  CarTrip = 'carTrip',
  FlightOnlyFromMarketplace = 'flightOnlyFromMarketplace',
  HotelOnlyFromMarketplace = 'hotelOnlyFromMarketplace',
  InfiniteLoadReload = 'infiniteLoadReload',
  MetaHotel = 'metaHotel',
  HotelSelectionForCountryFromMarketplace = 'hotelSelectionForCountryFromMarketplace',
}
